@if (pictures) {
<div class="container">
    @if (shownIndex > 0) {
    <button id="picture-previous-button"
        class="btn btn-previous"
        mat-icon-button
        (click)="browsePictures('before')">
        <mat-icon style="transform: scale(2);">navigate_before
        </mat-icon>
    </button>
    }
    @if (shownIndex < pictures.length - 1) {
    <button id="picture-next-button"
        class="btn btn-next"
        mat-icon-button
        (click)="browsePictures('after')">
        <mat-icon style="transform: scale(2);">navigate_next
        </mat-icon>
    </button>
    }

    @if (pictures[shownIndex].Description) {
    <div class="description">{{ pictures[shownIndex].Description | textTruncate:200 }}</div>
    }

    @if (useBlobImage) {
    <img [blobImage]="pictures[shownIndex].previewUrl">
    }
    @else {
    <img [src]="pictures[shownIndex].compressedPic">
    }

</div>
}